import { render, staticRenderFns } from "./dialogtreetable.vue?vue&type=template&id=64240ae4&scoped=true&"
import script from "./dialogtreetable.vue?vue&type=script&lang=js&"
export * from "./dialogtreetable.vue?vue&type=script&lang=js&"
import style0 from "./dialogtreetable.vue?vue&type=style&index=0&id=64240ae4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64240ae4",
  null
  
)

export default component.exports